import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "strong",
    [
      _vm._v(_vm._s(_vm.$t("chatbots.dashboard.organization_resources"))),
      _c(
        VRow,
        { staticClass: "pb-2 pr-2 pt-1" },
        [
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2 pr-0",
            },
            [
              _c(
                VCard,
                { attrs: { "max-height": "140px", "min-height": "140px" } },
                [
                  _c(
                    VCardTitle,
                    { class: _vm.titleClass },
                    [
                      _c(
                        VIcon,
                        {
                          staticClass: "mr-2",
                          style: _vm.iconStyle,
                          attrs: { color: "white" },
                        },
                        [_vm._v("mdi mdi-animation theme--light")]
                      ),
                      _vm._v(
                        _vm._s(_vm.$t("chatbots.dashboard.resources.projects"))
                      ),
                    ],
                    1
                  ),
                  _c(VRow, { attrs: { justify: "center" } }),
                  _c(
                    VCardText,
                    { class: _vm.textClass, staticStyle: { height: "100%" } },
                    [_c("h4", [_vm._v(_vm._s(_vm.total_projects))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2 pr-0",
            },
            [
              _c(
                VCard,
                { attrs: { "max-height": "140px", "min-height": "140px" } },
                [
                  _c(
                    VCardTitle,
                    { class: _vm.titleClass },
                    [
                      _c(
                        VIcon,
                        {
                          staticClass: "mr-2",
                          style: _vm.iconStyle,
                          attrs: { color: "white" },
                        },
                        [_vm._v(" mdi mdi-forum-outline theme--light")]
                      ),
                      _vm._v(
                        _vm._s(
                          _vm.$t("chatbots.dashboard.resources.total_messages")
                        )
                      ),
                    ],
                    1
                  ),
                  _c(VRow, { attrs: { justify: "center" } }),
                  _c(
                    VCardText,
                    { class: _vm.textClass, staticStyle: { height: "100%" } },
                    [_c("h4", [_vm._v(_vm._s(_vm.total_messages))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2 pr-0",
            },
            [
              _c(
                VCard,
                { attrs: { "max-height": "140px", "min-height": "140px" } },
                [
                  _c(
                    VCardTitle,
                    { class: _vm.titleClass },
                    [
                      _c(
                        VIcon,
                        {
                          staticClass: "mr-2",
                          style: _vm.iconStyle,
                          attrs: { color: "white" },
                        },
                        [_vm._v("mdi mdi-forum-outline theme--light")]
                      ),
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "chatbots.dashboard.resources.total_messages_personal"
                          )
                        )
                      ),
                    ],
                    1
                  ),
                  _c(VRow, { attrs: { justify: "center" } }),
                  _c(
                    VCardText,
                    { class: _vm.textClass, staticStyle: { height: "100%" } },
                    [_c("h4", [_vm._v(_vm._s(_vm.total_messages_personal))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            {
              staticClass:
                "col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 mt-2 pr-0",
            },
            [
              _c(
                VCard,
                { attrs: { "max-height": "140px", "min-height": "140px" } },
                [
                  _c(
                    VCardTitle,
                    { class: _vm.titleClass },
                    [
                      _c(
                        VIcon,
                        {
                          staticClass: "mr-2",
                          style: _vm.iconStyle,
                          attrs: { color: "white" },
                        },
                        [_vm._v("mdi mdi-forum-outline theme--light")]
                      ),
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "chatbots.dashboard.resources.last_session_messages"
                          )
                        )
                      ),
                    ],
                    1
                  ),
                  _c(VRow, { attrs: { justify: "center" } }),
                  _c(
                    VCardText,
                    { class: _vm.textClass, staticStyle: { height: "100%" } },
                    [_c("h4", [_vm._v(_vm._s(_vm.last_session_messages))])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }